module.exports = __webpack_public_path__ + "static/img/38.0210094d.png";